import {
    type CollectionWagsListing,
    listingSectionData,
} from "@/features/listings";
import {
    calculateDistance,
    staticMapSrc,
    useSeekerState,
    useUserLocation,
} from "@/features/viewer-location";

export function useListingSectionData(
    dog: CollectionWagsListing | null | undefined,
) {
    const { location: userLocation } = useUserLocation();
    const seekerState = useSeekerState();
    const coords = dog?.organization?.location;
    const distanceMiles =
        userLocation && coords
            ? calculateDistance(
                  userLocation.lat,
                  userLocation.lon,
                  coords.y,
                  coords.x,
              )
            : null;
    const data = dog
        ? listingSectionData(dog, {
              distanceMiles,
              mapSrc: staticMapSrc(coords?.y, coords?.x),
              seekerState,
              fitPercent: null,
              fitLine: undefined,
          })
        : null;
    return data ? { data, loading: false } : { data: null, loading: true };
}
